import { Outlet } from '@umijs/max';
import { useSession, useTenant } from '@zhiyue/core';
import React from 'react';

/** Remount domain stores when tenant, organization or member changes. */
export default function SessionBoundary({ children }: React.PropsWithChildren) {
  const { currentUser } = useSession();
  const { currentTenantUuid } = useTenant();
  const user = currentUser as typeof currentUser & {
    organizationUuid?: string;
  };
  const key = [
    currentTenantUuid,
    user?.organizationUuid,
    user?.memberUuid,
  ].join(':');
  return <React.Fragment key={key}>{children ?? <Outlet />}</React.Fragment>;
}
